import { DateTime } from 'luxon';

import { Period } from 'dashboard/lib/unixTime';
import { Iso8601DateString } from 'lib/types';

export const dateDiff = (date1: Iso8601DateString, date2: Iso8601DateString) => {
  return Math.floor(Math.abs(DateTime.fromISO(date1).diff(DateTime.fromISO(date2), 'days').days));
};

export const getEffectivePeriod = (
  period: Period,
  dateRange: [Iso8601DateString | undefined, Iso8601DateString | undefined],
) => {
  // Ensure that we're constraining selections based off of the date range
  if (dateRange[0] == null || dateRange[1] == null) {
    return period;
  }

  // Get the difference between two ISO Date Strings in Days
  const daysDifference = dateDiff(dateRange[0], dateRange[1]);

  // For a date Range of 0-28 Days, we'll allow all dates
  if (daysDifference <= 28) {
    return period;
  }

  // For a date range of 29-182 days, we'll allow daily, weekly and monthly
  else if (daysDifference <= 182 && period === Period.Hour) {
    return Period.Week;
  }

  // For a date range of 182+ days, we'll allow weekly and monthly
  else if (daysDifference > 182 && (period === Period.Hour || period === Period.Day)) {
    return Period.Month;
  }

  return period;
};

export const gatherPeriodOptions = (
  dateRange: [Iso8601DateString | undefined, Iso8601DateString | undefined],
) => {
  // Ensure that we're constraining selections based off of the date range
  if (dateRange[0] == null || dateRange[1] == null) {
    return [
      { label: 'Hourly', value: Period.Hour },
      { label: 'Daily', value: Period.Day },
      { label: 'Weekly', value: Period.Week },
      { label: 'Monthly', value: Period.Month },
    ];
  }

  const daysDiff = dateDiff(dateRange[0], dateRange[1]);

  if (daysDiff > 182) {
    return [
      { label: 'Weekly', value: Period.Week },
      { label: 'Monthly', value: Period.Month },
    ];
  } else if (daysDiff > 28) {
    return [
      { label: 'Daily', value: Period.Day },
      { label: 'Weekly', value: Period.Week },
      { label: 'Monthly', value: Period.Month },
    ];
  } else {
    return [
      { label: 'Hourly', value: Period.Hour },
      { label: 'Daily', value: Period.Day },
      { label: 'Weekly', value: Period.Week },
      { label: 'Monthly', value: Period.Month },
    ];
  }
};
